import { InputText } from '@pentabd/ui';
import { Controller } from 'react-hook-form';

interface Props {
  control: any;
  errors?: any;
  name: string;
  defaultValue?: any;
  placeholder?: string;
  title?: string;
  subtitle?: string;
}

const TextInput = ({
  control,
  name,
  defaultValue,
  placeholder,
  errors,
  title,
  subtitle,
}: Props) => {
  return (
    <Controller
      name={name}
      defaultValue={defaultValue}
      control={control}
      render={({ field }) => (
        <InputText
          title={title}
          subtitle={subtitle}
          error={errors ? errors?.[name]?.message : ''}
          placeholder={placeholder}
          {...field}
        />
      )}
    />
  );
};

export default TextInput;
